/**
 * Which landing page a visitor sees: the current one, or the remodelled one
 * (the "v2" page: seed-packet scan story, photo scrapbook, Plant Doctor,
 * share, frost warnings, gardens, price, end).
 *
 * The remodel is not live. It shows when the owner's Grow setting
 * landing.V2 is on (off unless the owner turns it on), or when the address has ?landing=v2,
 * which is how the owner reviews it while the setting stays off. Everyone
 * else keeps the current page.
 *
 * Pure: the setting and the address's query are passed in, so the same
 * function draws the page and is tested (landingVersion.test.mjs).
 *
 * Who uses it: LandingPage.
 *
 * @module landingVersion
 */

/**
 * Whether to show the remodelled landing page.
 *
 * @param isOn - The Grow setting landing.V2, as the landing read sends it (facts.v2).
 * @param search - The address's query, such as "?landing=v2".
 * @returns True for the remodelled page; false for the current one.
 */
export function showsLandingV2(isOn: boolean, search: string): boolean {
  if (isOn) return true;
  try {
    return new URLSearchParams(search).get('landing')?.trim().toLowerCase() === 'v2';
  } catch {
    return false;
  }
}
